import { groupBy } from "lodash"

interface GroupedArray {
  groupName: string
  items: any[]
}

export const groupByKey = (items: any[], key: any): GroupedArray[] => {
  const grouped = groupBy(items, key)
  return Object.keys(grouped).map((groupName) => ({
    groupName,
    items: grouped[groupName],
  }))
}
